import React from "react";
import qrCodeImage from "./qrcode.jpg"; // Assuming you have a QR code image imported
import "./Enrollment.css";

const Enrollment = () => {
  const handleFillForm = () => {
    window.location.href =
      "https://docs.google.com/forms/d/e/1FAIpQLSfKWc7ouEiinQaGSIhBO96s3y_-ONvI9Uhj_MSxcBepBzfUoQ/viewform";
  };

  return (
    <div className="enrollment-container">
      <h2>Payment Details</h2>
      <p>Price: ₹6000 for 4 months</p>
      <h2>Scan QR Code for Payment</h2>
      <button>Scan QR Code</button>
      <img src={qrCodeImage} alt="QR Code" />

      <h2>Fillout The Form</h2>
      <button onClick={handleFillForm}>Fill Form</button>
    </div>
  );
};

export default Enrollment;
